import React, { Suspense, lazy, useEffect } from 'react'
import Box from '@mui/material/Box'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { resetRoutingTooltipCacheByAccountId, setRoutingServiceDate } from 'slices/customer/customerDetailsSlice'
import RoutingServiceList from './RoutingServiceList'
import RoutingCalendar from './RoutingCalendar'

const BulkMoveStopsBetweenRoutesDialog = lazy(() =>
  import('components/route-manager/BulkActions/BulkMoveStopsBetweenRoutesDialog/BulkMoveStopsBetweenRoutesDialog')
)

const Routing = ({
  accountId,
  locationId,
  isActive,
  routingHeatmap,
  routesByDate,
  isCalendarLoading,
  expandWindowIfNeeded,
  ensureDateInWindow,
}) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setRoutingServiceDate(new Date()))
    dispatch(resetRoutingTooltipCacheByAccountId())
  }, [])

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: { xs: 'center', md: 'stretch' },
          width: '100%',
          p: 2,
        }}
      >
        <Box sx={{ width: { xs: 'auto', md: 420 }, flexShrink: 0, mb: 2 }}>
          <RoutingCalendar
            locationId={locationId}
            isActive={isActive}
            heatmap={routingHeatmap}
            dayMetaByDate={routesByDate}
            isLoading={isCalendarLoading}
            expandWindowIfNeeded={expandWindowIfNeeded}
            ensureDateInWindow={ensureDateInWindow}
          />
        </Box>
        <Box sx={{ flex: 1, minWidth: 0, px: 2 }}>
          <RoutingServiceList accountId={accountId} locationId={locationId} />
        </Box>
      </Box>
      <Suspense fallback={null}>
        <BulkMoveStopsBetweenRoutesDialog />
      </Suspense>
    </>
  )
}

Routing.propTypes = {
  accountId: PropTypes.string.isRequired,
  locationId: PropTypes.string,
  isActive: PropTypes.bool,
  routingHeatmap: PropTypes.object,
  routesByDate: PropTypes.object,
  isCalendarLoading: PropTypes.bool,
  expandWindowIfNeeded: PropTypes.func,
  ensureDateInWindow: PropTypes.func,
}

export default Routing
